import { type FC } from "react";
import { BrowserRouter } from "react-router";

import { type CheckoutV2ConfigurationBuilder } from "@jti/commerce";
import { CountrySetter } from "@jti/commerce/features";
import { InsertGoogleRecaptcha } from "@jti/ui/components/InsertGoogleRecaptcha/InsertGoogleRecaptcha";

import { CheckoutV2ConfigurationProvider } from "@checkout-v2/shared/providers/CheckoutV2ConfigurationProvider";

import { SinglePageCheckoutAppRouter } from "./SinglePageCheckoutAppRouter";

/**
 * Props for the SinglePageCheckoutApp component.
 *
 * @property data - The checkout configuration object required to initialize the checkout process.
 * @property basename - (Optional) The base URL path for routing within the checkout app, e.g., "/checkout-v2". Defaults to "/".
 * @property onNavigate - (Optional) Host navigation handler for leaving the checkout app (e.g. Next.js router). Falls back to a full page navigation.
 */
export type SinglePageCheckoutAppProps = {
  data: CheckoutV2ConfigurationBuilder;
  basename?: string;
  onNavigate?: (url: string) => void;
};

export const SinglePageCheckoutApp: FC<SinglePageCheckoutAppProps> = ({ data, basename = "/", onNavigate }) => {
  return (
    <>
      <InsertGoogleRecaptcha />

      <BrowserRouter basename={basename}>
        <CheckoutV2ConfigurationProvider data={data}>
          <CountrySetter />
          <SinglePageCheckoutAppRouter onNavigate={onNavigate} />
        </CheckoutV2ConfigurationProvider>
      </BrowserRouter>
    </>
  );
};
